import { lazy } from 'react';
import { ComponentsMapInterface } from './types';

export enum ComponentsMapEnums {
  CREATE_INCENTIVE,
  INCENTIVE_MANAGEMENT,
  ATTENDANCE_INCENTIVE,
  PERFORMANCE_INCENTIVE,
  INCENTIVE_VIEW,
}

export const ComponentsMap: ComponentsMapInterface = {
  CREATE_INCENTIVE: lazy(() => import('../pages/create-incentive')),
  INCENTIVE_MANAGEMENT: lazy(() => import('../pages/incentives')),
  ATTENDANCE_INCENTIVE: lazy(() => import('../pages/attendance-incentive')),
  PERFORMANCE_INCENTIVE: lazy(() => import('../pages/performance-incentive')),
  INCENTIVE_VIEW: lazy(() => import('../pages/incentive-view')),
};
